import React, { FC, useState } from "react";
import { YHModal } from "@/erp_subpackage/components/YHModal";
import { usePurchasePoDetailsModel } from "./purchasePoDetailModel";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { Table, Select, message } from "antd";
import useGlobalModel, { transOptions } from "@/erp_subpackage/model/globalModel";
import { warehouseService } from "@/erp_subpackage/pages/base/warehouse/warehouseService";

export const AddTempShelfModal = ({ id, mode }) => {

	const {
		addTempShelfModal: visible,
		setAddTempShelfModal,
		editList,
		editFormVal,
		warehouseData,
		addList,
		detailAddForm,
		setEditList, setAddList,
		lookFormVal
	} = usePurchasePoDetailsModel();
	let dataList = mode === 'add' ? addList : editList
	const detailForm = mode === "add" ? detailAddForm : mode === "edit" ? editFormVal : lookFormVal;
	const { user: { shopId, shopName, shopCode }, whDs, setMaterialInfo } = useGlobalModel(({ user, whDs }) => [user, whDs]);
	const [shelfInfo, setShelfInfo] = useState(null);  //记录选中的货位信息

	const onCancel = () => {
		setAddTempShelfModal(false);
		setShelfInfo(null);
	};

	//货位列表 Api
	const shelfLoadData = async (whObj) => {
		const searchParams = {
			shopId, shopName, shopCode,
			warehouseCode: whObj.value,
			code: "临时货位",
			pageSize: -1,
			pageNum: 1,
		}

		let { retData } = await warehouseService.shelfPage(searchParams);
		const { records, ...pg } = retData;
		if (!records || !records.length) {
			message.warning("该仓库下没有临时货位，请联系后台人员添加");
			setShelfInfo(null);
			return;
		}
		let newData = records.find((item) => item.code == '临时货位')
		setShelfInfo(newData);
	}

	const onSubmit = () => {
		if (!shelfInfo) {
			message.warning("请选择仓库或者该仓库没有临时货位");
			return;
		}
		mode === "edit" ? setEditList(origin => origin.map(item => {
			if (!item.shelfCode) {
				return {
					...item,
					shelfId: shelfInfo.id,   //货位Id
					shelfCode: shelfInfo.code,   //货位编码
					warehouseName: shelfInfo.warehouseName,   //仓库名称
					warehouseCode: shelfInfo.warehouseCode,  //仓库编码
					warehouseId: shelfInfo.warehouseId,  //仓库编码
					isShelfCode: true
				}
			};
			return item;
		})) : setAddList(origin => origin.map(item => {
			if (!item.shelfCode) {
				return {
					...item,
					shelfId: shelfInfo.id,   //货位Id
					shelfCode: shelfInfo.code,   //货位编码
					warehouseName: shelfInfo.warehouseName,   //仓库名称
					warehouseCode: shelfInfo.warehouseCode,  //仓库编码
					warehouseId: shelfInfo.warehouseId,  //仓库编码
					isShelfCode: true
				}
			};
			return item;
		}))
		onCancel();
	}

	const columns = [
		{
			title: '序号',
			fixed: "left",
			width: 60,
			align: "center",
			render: (t, r, i) => i + 1
		}, {
			title: '商品编号',
			align: "center",
			dataIndex: 'materialCode',
		}, {
			title: '商品名称',
			align: "center",
			dataIndex: 'materialName',
		}
	];

	const rightChildren = <div>
		<span className="label-name">仓库：</span>
		<Select
			style={{ width: 260 }}
			options={whDs}  //过滤掉直发库
			placeholder="请选择仓库"
			onChange={(value, option) => {
				value && shelfLoadData(option)
			}}
		/>
	</div>



	return <YHModal
		visible={visible}
		onOk={onSubmit}
		onCancel={onCancel}
		title="添加临时货位"
		width={'70%'}
		bodyHeight={400}
		showFooter={true}
	>
		<YhBox title={rightChildren} style={{ marginBottom: "15px" }}>
			<Table
				bordered
				columns={columns}
				dataSource={dataList.filter(item => !!!item.shelfCode)}
				pagination={false}
				scroll={{ x: 'max-content', }}
			/>
		</YhBox>
	</YHModal>
}